import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
`

export const fragment = (name = 'lithLogo') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
